import { NextPage } from 'next'
import { AppLayout, Container, FAQSection } from '@components'
import { NextSeo } from 'next-seo'

const FAQ: NextPage<{}> = () => {
  return (
    <AppLayout>
      <NextSeo
        title="Frequently Asked Questions"
        description="MarketX Ventures is a one-stop shop for over 300 family offices, funds, and
        high net worth individuals to access high growth investment
        opportunities."
        canonical="https://www.marketxventures.com/faq"
      />
      <Container>
        <FAQSection />
      </Container>
    </AppLayout>
  )
}

export default FAQ
